import React from 'react';
import PropTypes from 'prop-types';

import Link from '@marvelapp/marvel-ui/link';

export default function a({ children, href }) {
  return (
    <Link type="blue" url={href}>
      {children}
    </Link>
  );
}

a.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/markdown/a.js